/***
 * default prefix "CHAT"
 */

export const AT_UPDATE = 'CHAT_UPDATE';
